import { createAction } from "@reduxjs/toolkit";
import api from "../../services/api";

export const searchModel = createAction("SEARCH_MODEL");
export const addProject = createAction("ADD_PROJECT");
export const addModel = createAction("ADD_MODEL");
export const editModelFlow = createAction("EDIT_FLOW");

//Novos
export const removeElement = createAction("REMOVE_ELEMENT");
export const removeProject = createAction("REMOVE_PROJECT");
export const clearDashboard = createAction("CLEAR_DASHBOARD");
export const clearPane = createAction("CLEAR_PANE");
export const removeModelFlow = createAction("REMOVE_MODEL_FLOW");
export const renameFlow = createAction("RENAME_FLOW");
export const updateSingleFlow = createAction("UPDATE_SINGLE");
export const setDefault = createAction("SET_DEFAULT");
export const updateCurrent = createAction("UPDATE_CURRENT");

export const handleListProjects = () => {
  return (dispatch) =>
    api.get("/modelflows/list/").catch((err) => {
      throw new Error(err);
    });
};

//Adicionar Projeto
export const handleAddProject = ({ elements, flow }) => {
  return (dispatch) =>
    api
      .post("/modelflows/new", {
        elements,
        flow,
      })
      .then((res) => dispatch(addProjectSucess(res.data)))
      .catch((err) => dispatch(addProjectFailure(err.message)));
};
const addProjectSucess = (payload) => addProject(payload);

const addProjectFailure = (error) => {
  throw new Error(error);
};

//Adicionar Modelo (Versionamento)
export const handleAddModel = ({ elements, flow }) => {
  return (dispatch) =>
    api
      .post("/modelflows/new/model", {
        elements,
        flow,
      })
      .then((res) => dispatch(addModelSucess(res.data)))
      .catch((err) => dispatch(addModelFailure(err.message)));
};
const addModelSucess = (payload) => addModel(payload);

const addModelFailure = (error) => {
  throw new Error(error);
};

//Copiar Fluxo
export const handleCopyModelFlow = ({ flowId, title }) => {
  return (dispatch) =>
    api
      .post("/modelflows/copy", {
        flowId,
        title,
      })
      .catch((err) => dispatch(copyModelFlowFailure(err.message)));
};

const copyModelFlowFailure = (error) => {
  throw new Error(error);
};

//Procurar Fluxo
export const handleSearchFlow = ({ title, page }) => {
  return (dispatch) =>
    api
      .get("/modelflows/search/" + page + "/" + title + "/")
      .then((res) => dispatch(searchSucess(res.data)))
      .catch((err) => dispatch(searchFailure(err.message)));
};

const searchSucess = (payload) => searchModel(payload);

const searchFailure = (error) => {
  throw new Error(error);
};

//Remover Projeto
export const handleRemoveProject = (flowId) => {
  return (dispatch) =>
    api
      .delete(`/modelflows/project/${flowId}`)
      .then((res) => dispatch(removeProjectSucess(res.data)))
      .catch((err) => dispatch(removeProjectFailure(err.message)));
};
const removeProjectSucess = (payload) => removeProject(payload);

const removeProjectFailure = (error) => {
  throw new Error(error);
};

//Remover um fluxo
export const handleRemoveModel = (flowId) => {
  return (dispatch) =>
    api
      .delete(`/modelflows/flow/${flowId}`)
      .then((res) => dispatch(removeModelFlowSucess(res.data)))
      .catch((err) => dispatch(removeModelFlowFailure(err.message)));
};

const removeModelFlowSucess = (payload) => removeModelFlow(payload);

const removeModelFlowFailure = (error) => {
  throw new Error(error);
};

export const handleRenameFlow = ({ title, flowId, parentId }) => {
  return (dispatch) =>
    api
      .put("/modelflows/rename", {
        title,
        flowId,
        parentId,
      })
      .then((res) => dispatch(renameFlowSucess(res.data)))
      .catch((err) => dispatch(renameFlowFailure(err.message)));
};

const renameFlowSucess = (payload) => renameFlow(payload);
const renameFlowFailure = (error) => {
  throw new Error(error);
};
//Editar Fluxo
export const handleEditModelFlow = ({ elements, title, flowId }) => {
  return (dispatch) =>
    api
      .put("/modelflows/edit", {
        elements,
        title,
        flowId,
      })
      .then((res) => dispatch(editModelFlowSucess(res.data)))
      .catch((err) => dispatch(editModelFlowFailure(err.message)));
};

const editModelFlowSucess = (payload) => editModelFlow(payload);

const editModelFlowFailure = (error) => {
  throw new Error(error);
};

//Definir Padrão
export const handleSetDefault = ({ flowId, versionId }) => {
  return (dispatch) =>
    api
      .put("/modelflows/default", {
        flowId,
        versionId,
      })
      .then((res) => dispatch(newDefaultVersionFlowSucess(res.data)))
      .catch((err) => dispatch(newDefaultVersionFlowFailure(err.message)));
};

const newDefaultVersionFlowSucess = (payload) => setDefault(payload);

const newDefaultVersionFlowFailure = (error) => {
  throw new Error(error);
};
